// extracted by mini-css-extract-plugin
module.exports = {"tagLine":"TagLine_tagLine__OsRgT","wrapper":"TagLine_wrapper__GiKNg","tagLabel":"TagLine_tagLabel__Y8qXu","tagIcon":"TagLine_tagIcon__fxmmf"};